import React from 'react';

const PerformanceMonitoringIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14M12 11.3333V6M8.66667 11.3333V3.33333M5.33333 11.3333V9.33333'
        stroke='#232222'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PerformanceMonitoringIcon;
